import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider } from "@material-ui/core";
import { useFormContext } from "react-hook-form";
import { useAlert, useSchemaProviderContext } from "hooks";
import { SecondaryButton } from "components";
import { useMaterialDetailsForm } from "hooks/api/useMaterialDetailsForm";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";

export const FormControls = () => {
    const { t } = useTranslation();
    const { toggleAlert } = useAlert();
    const { handleSubmit } = useFormContext();
    const { isEdit, toggleEdit, actionFields, refetch } = useSchemaProviderContext();
    const { selectedMaterialId, selectedMaterialSpecId } = useMaterialSpecs();
    const [mutate, { isSuccess, isError }] = useMaterialDetailsForm(selectedMaterialSpecId, selectedMaterialId);

    // eslint-disable-next-line
    const onSubmit = async (formValues: any) => {
        /**
         * TODO: for some reasons dirty check is NOT WORKING for date fields... fix this in te future and DO NOT submit
         * if fields didn't change
         */
        await mutate({ formValues });
        await refetch();

        toggleEdit();
    };

    useEffect(() => {
        if (isSuccess) {
            toggleAlert({ message: t("general.label.changesSaved"), type: "success" });

            return toggleEdit();
        }

        if (isError) {
            toggleAlert({ message: t("general.errors.savingError"), type: "error" });
        }
    }, [isSuccess, isError, toggleEdit, toggleAlert, t]);

    // don't show edit button if there isn't anything that can be edited
    if (actionFields.length === 0) {
        return null;
    }

    return (
        <Box width="100%" mt={1} pb={1} position="sticky" bottom={0} right={0} bgcolor="white">
            <Box pb={1}>
                <Divider />
            </Box>
            <Box display="flex" justifyContent="flex-end">
                {isEdit ? (
                    <>
                        <SecondaryButton
                            disableRipple
                            variant="outlined"
                            color="primary"
                            onClick={handleSubmit(onSubmit)}>
                            {t("buttons.label.submit")}
                        </SecondaryButton>
                        <SecondaryButton disableRipple variant="outlined" color="primary" onClick={toggleEdit} ml={2}>
                            {t("buttons.label.cancel")}
                        </SecondaryButton>
                    </>
                ) : (
                    <SecondaryButton disableRipple variant="outlined" color="primary" onClick={toggleEdit} ml={2}>
                        {t("buttons.label.edit")}
                    </SecondaryButton>
                )}
            </Box>
        </Box>
    );
};
